<section
  class="flex flex-col h-full bg-base-100 border-r border-base-200 transition-[width] duration-300 ease-in-out overflow-hidden"
  [style.width]="collapsed() ? '4.5rem' : '16rem'">
  <!-- 로고 + 토글 버튼 -->
  <div
    class="h-20 min-h-20 px-4 flex items-center bg-base-100 select-none overflow-hidden"
    [class.justify-between]="!collapsed()"
    [class.justify-center]="collapsed()">
    <div
      class="flex items-center gap-3 min-w-0 overflow-hidden transition-opacity duration-200"
      [class.opacity-0]="collapsed()"
      [class.w-0]="collapsed()"
      [class.opacity-100]="!collapsed()">
      <div
        class="flex items-center justify-center p-2 bg-primary/5 border border-primary/10 rounded-xl shadow-[0_2px_8px_-2px_oklch(var(--p)/0.1)] shrink-0">
        <img class="w-6 h-6 object-contain" [src]="logo() || 'https://lepisode.team/assets/logo.svg'" alt="logo" />
      </div>
      <span class="text-lg font-bold text-base-content tracking-tight whitespace-nowrap">{{ title() }}</span>
    </div>
    <button
      (click)="toggleCollapse.emit()"
      class="cursor-pointer size-9 flex items-center justify-center rounded-lg hover:bg-base-200 transition-colors text-base-content/40 hover:text-base-content/70 shrink-0">
      <span
        class="text-xl transition-transform duration-300"
        [class]="collapsed() ? 'icon-[mdi--chevron-double-right]' : 'icon-[mdi--chevron-double-left]'"></span>
    </button>
  </div>

  <!-- 메뉴 영역 -->
  <div class="flex flex-col gap-1 overflow-y-auto scroll-none flex-1 p-3">
    <ng-content />
  </div>
</section>
